import { Feature } from '@tencent/workbench';
import { config } from './config';
import { PlayActionFeature } from '../../titlebar/features/play-action-feature';

@Feature()
export class RemotePlayFeature extends PlayActionFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public onClick() {
        this.handleRemotePlayClick();
    }

    public shouldHide() {
        return !this.showRemotePlay();
    }
}
